import {
  Location,
  LocationStrategy,
  PathLocationStrategy
} from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from '@angular/material/core';
import { NavigationEnd, Router } from '@angular/router';
import * as moment from 'moment';
import { Moment } from 'moment';
import { CommonService } from 'src/app/services';
import { DataService } from 'src/app/services/data.service';
import { AlertService, Constants } from 'src/app/shared';

@Component({
  selector: 'app-energy-tree-excel',
  templateUrl: './energy-tree-excel.component.html',
  styleUrls: ['./energy-tree-excel.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: Constants.DATE_RANGES_PROVIDER_FORMAT
    },
    Location,
    { provide: LocationStrategy, useClass: PathLocationStrategy }
  ]
})

/**
 *
 *
 * @export
 * @class EnergyTreeExcelComponent
 * @implements {OnInit}
 */
export class EnergyTreeExcelComponent implements OnDestroy {
  siteId = '';
  siteName = '';
  max = new Date();
  dateBound: number = null;
  startDateCtr = new UntypedFormControl(moment());
  endDateCtr = new UntypedFormControl(moment());
  isValidStartDate = true;
  startDateErrorMessage: String;
  isValidEndDate = true;
  endDateErrorMessage: String;
  navigationSubscription: any;
  fileName: string;

  /**
   * Creates an instance of EnergyTreeExcelComponent.
   * @param {CommonService} commonService
   * @param {DataService} dataService
   * @param {AlertService} alertService
   * @param {Router} router
   * @memberof EnergyTreeExcelComponent
   */
  constructor(
    public commonService: CommonService,
    private dataService: DataService,
    private alertService: AlertService,
    private router: Router,
    public location: Location
  ) {
    this.max.setDate(this.max.getDate() - 1);
    this.startDateCtr.patchValue(moment().subtract(1, 'days'));
    this.endDateCtr.patchValue(moment().subtract(1, 'days'));
    //Get SiteId
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.siteId = localStorage.getItem('siteId');
        this.siteName = localStorage.getItem('siteName');
      }
    });
  }

  /**
   * Function to destroy subscriptions
   *
   * @memberof EnergyTreeExcelComponent
   */
  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  /**
   * Function call to check validations for Start Date
   *
   * @memberof EnergyTreeExcelComponent
   */
  validateStartDate() {
    var modelData = this.commonService.validateStartDate(
      this.dateBound,
      this.startDateCtr,
      this.endDateCtr,
      this.isValidStartDate,
      this.isValidEndDate,
      this.startDateErrorMessage,
      this.endDateErrorMessage
    );
    this.startDateCtr = modelData.startDateCtr;
    this.endDateCtr = modelData.endDateCtr;
    this.isValidEndDate = modelData.isValidEndDate;
    this.isValidStartDate = modelData.isValidStartDate;
    this.startDateErrorMessage = modelData.startDateErrorMessage;
    this.endDateErrorMessage = modelData.endDateErrorMessage;
    console.log(
      this.startDateCtr,
      this.endDateCtr,
      this.isValidStartDate,
      this.isValidEndDate,
      this.startDateErrorMessage,
      this.endDateErrorMessage
    );
  }

  /**
   * Function call to check validations for End Date
   *
   * @memberof EnergyTreeExcelComponent
   */
  validateEndDate() {
    var modelData = this.commonService.validateEndDate(
      this.dateBound,
      this.startDateCtr,
      this.endDateCtr,
      this.isValidStartDate,
      this.isValidEndDate,
      this.startDateErrorMessage,
      this.endDateErrorMessage
    );
    this.startDateCtr = modelData.startDateCtr;
    this.endDateCtr = modelData.endDateCtr;
    this.isValidEndDate = modelData.isValidEndDate;
    this.isValidStartDate = modelData.isValidStartDate;
    this.startDateErrorMessage = modelData.startDateErrorMessage;
    this.endDateErrorMessage = modelData.endDateErrorMessage;
    console.log(
      this.startDateCtr,
      this.endDateCtr,
      this.isValidStartDate,
      this.isValidEndDate,
      this.startDateErrorMessage,
      this.endDateErrorMessage
    );
  }

  /**
   * Function call on change of year in start datepicker
   *
   * @param {Moment} normalizedYear
   * @memberof EnergyTreeExcelComponent
   */
  chosenStartDate_YearHandler(normalizedYear: Moment) {
    const ctrlValue = this.startDateCtr.value;
    ctrlValue.year(normalizedYear.year());
    this.startDateCtr.setValue(ctrlValue);
  }

  /**
   * Function call on change of month in start datepicker
   *
   * @param {Moment} normalizedMonth
   * @memberof EnergyTreeExcelComponent
   */
  chosenStartDate_MonthHandler(normalizedMonth: Moment) {
    const ctrlValue = this.startDateCtr.value;
    ctrlValue.month(normalizedMonth.month());
    this.startDateCtr.setValue(ctrlValue);
  }

  /**
   * Function call on change of year in End datepicker
   *
   * @param {Moment} normalizedYear
   * @memberof EnergyTreeExcelComponent
   */
  chosenEndDate_YearHandler(normalizedYear: Moment) {
    const ctrlValue = this.endDateCtr.value;
    ctrlValue.year(normalizedYear.year());
    this.endDateCtr.setValue(ctrlValue);
  }

  /**
   * Function call on change of month in End datepicker
   *
   * @param {Moment} normalizedMonth
   * @memberof EnergyTreeExcelComponent
   */
  chosenEndDate_MonthHandler(normalizedMonth: Moment) {
    const ctrlValue = this.endDateCtr.value;
    ctrlValue.month(normalizedMonth.month());
    this.endDateCtr.setValue(ctrlValue);
  }

  /**
   * Function to go back to overview page
   *
   * @memberof EnergyTreeExcelComponent
   */
  backClick() {
    this.router.navigate(['site', 'over-view'], {
      queryParams: { siteId: this.siteId }
    });
  }

  /**
   * Function call happen when user clicks ok button with buttonId generate-excel-report
   *
   * @memberof EnergyTreeExcelComponent
   */
  ok() {
    let url = '';
    let reportName = 'EnergyReport';
    //Change value of Date into String
    var fromDate = this.commonService.transform(this.startDateCtr);
    var toDate = this.commonService.transform(this.endDateCtr);

    //API call to get Energy tree excel Report url
    url = this.commonService.getEnergyTreeReportUrl(
      this.siteId,
      fromDate,
      toDate
    );

    this.fileName =
      this.siteName + '_' + reportName + '_' + fromDate + '_' + toDate;

    this.dataService.getPDF(url, true).subscribe((response) => {
      if (response.byteLength > 0) {
        const file = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const fileURL = URL.createObjectURL(file);
        // Provide filename to the exported file
        const fileName = document.createElement('a');
        fileName.href = fileURL;
        fileName.download = this.fileName;
        fileName.click();
        URL.revokeObjectURL(fileURL);
      } else {
        this.alertService.message = 'No Data present for selected duration';
        this.alertService.showError();
      }
    });
  }
  goToBack() {
    this.location.back();
  }
}
